module.exports = __webpack_public_path__ + "static/media/largeDeliveryTruck_blue.573af78d.svg";